import type { Phase } from "@/hooks/useBooth.ts";

const LABEL: Record<Phase, string> = {
  idle: "Ready",
  "requesting-mic": "Microphone…",
  connecting: "Connecting…",
  live: "Live",
  reconnecting: "Reconnecting…",
  finalizing: "Finishing…",
  stopped: "Stopped",
  error: "Error",
};

const TONE: Record<Phase, string> = {
  idle: "bg-faint",
  "requesting-mic": "bg-accent animate-pulse",
  connecting: "bg-accent animate-pulse",
  live: "bg-danger animate-pulse",
  reconnecting: "bg-accent animate-pulse",
  finalizing: "bg-accent",
  stopped: "bg-faint",
  error: "bg-danger",
};

export function StatusPill({ phase, label }: { phase: Phase; label?: string }) {
  return (
    <span
      className="inline-flex min-h-9 items-center gap-2 rounded-full border border-line bg-surface px-3 text-sm"
      role="status"
      aria-live="polite"
    >
      <span className={`h-2 w-2 rounded-full ${TONE[phase]}`} aria-hidden="true" />
      {label ?? LABEL[phase]}
    </span>
  );
}
